export const Permissions = {
    AssignUser: 'Assign User',
    BusinessCRUD: 'Business CRUD',
    UserManagement: 'User Management',
};
